<template>
  <!--  <lazy-dom>-->
  <div class="policy-form">
    <el-form
      ref="form"
      :rules="rules"
      :model="formData">
      <div class="box">
        <h3 v-if="!isRefer">Quote Details</h3>
        <template v-if="isCAR">
          <div class="form-item form-half">
            <span>Period of Insurance</span>
            <el-form-item
              ref="date"
              :rules="rules.select"
              prop="date">
              <v-date-picker
                v-model="formData.date"
                :clearable="true"
                type="daterange"
                @change="handleUpdateForm"
              />
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Maintenance Period</span>
            <el-form-item
              ref="main_date"
              :rules="rules.select"
              prop="main_date">
              <v-date-picker
                v-model="formData.main_date"
                :clearable="true"
                type="daterange"
                @change="handleUpdateForm"
              />
            </el-form-item>
          </div>
        </template>
        <div
          v-if="!isCAR"
          class="form-item form-half">
          <span>Expected Effective Date</span>
          <el-form-item
            ref="pcy_cmnt_dt"
            :rules="rules.select"
            prop="pcy_cmnt_dt"
          >
            <v-date-picker
              v-model="formData.pcy_cmnt_dt"
            />
          </el-form-item>
        </div>
        <div class="flex-sb">
          <div class="form-item form-half">
            <span>Insurer</span>
            <el-form-item
              ref="company_id"
              :rules="rules.select"
              prop="company_id"
            >
              <v-select
                v-model="formData.company_id"
                :block="true"
                :disabled="isRefer"
                :list="newSMEOptions.insurer"
                @change="handleUpdateData" />
            </el-form-item>
          </div>
        </div>
        <template   v-if="isRefer">
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Type of Insurance</span>
              <el-form-item
              >
                <v-select
                  v-model="form.class_id"
                  :block="true"
                  disabled
                  :list="classOptions" />
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Policyholder</span>
              <v-input
                v-model="form.isrd_nm"
                :disabled="true" />
            </div>
          </div>
          <div
            class="flex-sb">
            <div class="form-item form-half">
              <span>Quotation Number</span>
              <v-input
                v-model="form.quote_no"
                :disabled="true" />
            </div>
            <div class="form-item form-half">
              <span>Type of quotation</span>
              <v-select
                v-model="form.type"
                :disabled="true"
                :list="globalOptions.quote_type" />
            </div>
          </div>
        </template>
        <div class="form-item">
          <span>Plan Name</span>
          <el-form-item
            ref="plan_name"
            :rules="rules.input"
            prop="plan_name"
          >
            <v-input
              v-model="formData.plan_name"
              key-non-chinese
              uppercase
              @change="handleUpdateData"
            />
          </el-form-item>
        </div>
        <div class="flex flex-sb-center">
          <div class="form-item form-half">
            <span>Insurer Application Form</span>
            <el-form-item
              ref="prop_pdf_path"
              :rules="rules.upload"
              prop="prop_pdf_path">
              <file-container
                :fileData="formData.prop_pdf_path_file"
                :edit="true"
                is-show-detail
                :show-left-name="false"
                is-none-name
                :is-viewer="true"
                :otherData="{
                  target: 'prop_pdf_path_file',
                  idKey: 'prop_pdf_path',
                }"
                @delete="handlerDeleteFile"
                @uploadSuccess="handlerUploadSuccess"
              >
              </file-container>
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Insurer Official Quotation</span>
            <el-form-item
              ref="insurer_quotation_path"
              :rules="rules.upload"
              prop="insurer_quotation_path">
              <file-container
                :fileData="formData.insurer_quotation_path_file"
                :edit="true"
                is-show-detail
                :show-left-name="false"
                :is-viewer="true"
                is-none-name
                :otherData="{
                  target: 'insurer_quotation_path_file',
                  idKey: 'insurer_quotation_path'
                }"
                @delete="handlerDeleteFile"
                @uploadSuccess="handlerUploadSuccess"
              >
              </file-container>
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="box">
        <h3>Coverage</h3>
        <template v-if="isCAR">
          <div
            v-if="formData.materials_ind==1"
            class="form-item">
            <span>Material Damage (Section 1)</span>
            <el-form-item
              ref="cal_type_materials"
              :rules="rules.select"
              prop="cal_type_materials">
              <v-radio-group
                v-model="formData.cal_type_materials"
                :list="newSMEOptions.cal_type"
                @change="handleComputed"/>
            </el-form-item>
            <div class="flex-align-center mg-t-8">
              <template v-if="formData.cal_type_materials==1">
                <el-form-item
                  ref="materials_isrd"
                  :rules="rules.input"
                  prop="materials_isrd">
                  <v-input
                    v-model="formData.materials_isrd"
                    key-non-chinese
                    class="width-128"
                    :key-float-number="true"
                    prepend="$"
                    @change="handleComputed"
                  ></v-input>
                </el-form-item>

                <span class="mg-l-8 mg-r-8">
                  <font-awesome-icon icon="xmark"></font-awesome-icon>
                </span>
                <el-form-item
                  ref="materials_pct"
                  :rules="rules.input"
                  prop="materials_pct">
                  <v-input
                    v-model="formData.materials_pct"
                    class="width-68"
                    key-non-chinese
                    :key-float-number="true"
                    append="%"
                    @change="handleComputed"
                  ></v-input>
                </el-form-item>
                <span class="mg-l-8 mg-r-8">
                  <font-awesome-icon icon="equals"></font-awesome-icon>
                </span>
              </template>
              <el-form-item
                ref="materials_prm"
                :rules="rules.input"
                prop="materials_prm">
                <v-input
                  v-model="formData.materials_prm"
                  key-non-chinese
                  :disabled="formData.cal_type_materials==1"
                  class="width-128"
                  :key-float-number="true"
                  prepend="$"
                  @blur="handleComputed"
                ></v-input>
              </el-form-item>
              <template v-if="formData.cal_type_materials==1">
                <span class="mg-l-8 mg-r-8">
                  <font-awesome-icon icon="slash"></font-awesome-icon>
                </span>
                <span class="mg-r-8 fs-14 fw-600">mini </span>
                <el-form-item
                  ref="min_materials_prm"
                  :rules="rules.input"
                  prop="min_materials_prm">
                  <v-input
                    v-model="formData.min_materials_prm"
                    key-non-chinese
                    class="width-128"
                    :key-float-number="true"
                    prepend="$"
                    @change="handleComputed"
                  ></v-input>
                </el-form-item>
              </template>
            </div>
          </div>
          <div
            v-if="formData.pl_ind==1"
            class="form-item">
            <span>Third-Party Liability (Section 2)</span>
            <el-form-item
              ref="cal_type_pl"
              :rules="rules.select"
              prop="cal_type_pl">
              <v-radio-group
                v-model="formData.cal_type_pl"
                :list="newSMEOptions.cal_type"
                @change="handleComputed"/>
            </el-form-item>
            <div class="flex-align-center mg-t-8">
              <template v-if="formData.cal_type_pl==1">
                <el-form-item
                  ref="pl_isrd"
                  :rules="rules.input"
                  prop="pl_isrd">
                  <v-input
                    v-model="formData.pl_isrd"
                    key-non-chinese
                    class="width-128"
                    :key-float-number="true"
                    prepend="$"
                    @change="handleComputed"
                  ></v-input>
                </el-form-item>

                <span class="mg-l-8 mg-r-8">
                  <font-awesome-icon icon="xmark"></font-awesome-icon>
                </span>
                <el-form-item
                  ref="pl_pct"
                  :rules="rules.input"
                  prop="pl_pct">
                  <v-input
                    v-model="formData.pl_pct"
                    class="width-68"
                    key-non-chinese
                    :key-float-number="true"
                    append="%"
                    @change="handleComputed"
                  ></v-input>
                </el-form-item>
                <span class="mg-l-8 mg-r-8">
                  <font-awesome-icon icon="equals"></font-awesome-icon>
                </span>
              </template>
              <el-form-item
                ref="pl_prm"
                :rules="rules.input"
                prop="pl_prm">
                <v-input
                  v-model="formData.pl_prm"
                  key-non-chinese
                  :disabled="formData.cal_type_pl==1"
                  class="width-128"
                  :key-float-number="true"
                  prepend="$"
                  @blur="handleComputed"
                ></v-input>
              </el-form-item>
              <template v-if="formData.cal_type_pl==1">
                <span class="mg-l-8 mg-r-8">
                  <font-awesome-icon icon="slash"></font-awesome-icon>
                </span>
                <span class="mg-r-8 fs-14 fw-600">mini </span>
                <el-form-item
                  ref="min_pl_prm"
                  :rules="rules.input"
                  prop="min_pl_prm">
                  <v-input
                    v-model="formData.min_pl_prm"
                    key-non-chinese
                    class="width-128"
                    :key-float-number="true"
                    prepend="$"
                    @change="handleComputed"
                  ></v-input>
                </el-form-item>
              </template>
            </div>
          </div>
          <div
            v-if="formData.employee_ind==1"
            class="form-item">
            <span>Employee’s Compensation (Section 3)</span>
            <el-form-item
              ref="cal_type_ec"
              :rules="rules.select"
              prop="cal_type_ec">
              <v-radio-group
                v-model="formData.cal_type_ec"
                :list="newSMEOptions.cal_type"
                @change="handleComputed"/>
            </el-form-item>
            <div class="flex-align-center mg-t-8">
              <template v-if="formData.cal_type_ec==1">
                <el-form-item
                  ref="ec_isrd"
                  :rules="rules.input"
                  prop="ec_isrd">
                  <v-input
                    v-model="formData.ec_isrd"
                    key-non-chinese
                    class="width-128"
                    :key-float-number="true"
                    prepend="$"
                    @change="handleComputed"
                  ></v-input>
                </el-form-item>

                <span class="mg-l-8 mg-r-8">
                  <font-awesome-icon icon="xmark"></font-awesome-icon>
                </span>
                <el-form-item
                  ref="ec_pct"
                  :rules="rules.input"
                  prop="ec_pct">
                  <v-input
                    v-model="formData.ec_pct"
                    class="width-68"
                    key-non-chinese
                    :key-float-number="true"
                    append="%"
                    @change="handleComputed"
                  ></v-input>
                </el-form-item>
                <span class="mg-l-8 mg-r-8">
                  <font-awesome-icon icon="equals"></font-awesome-icon>
                </span>
              </template>
              <el-form-item
                ref="ec_prm"
                :rules="rules.input"
                prop="ec_prm">
                <v-input
                  v-model="formData.ec_prm"
                  key-non-chinese
                  :disabled="formData.cal_type_ec==1"
                  class="width-128"
                  :key-float-number="true"
                  prepend="$"
                  @blur="handleComputed"
                ></v-input>
              </el-form-item>
              <template v-if="formData.cal_type_ec==1">
                <span class="mg-l-8 mg-r-8">
                  <font-awesome-icon icon="slash"></font-awesome-icon>
                </span>
                <span class="mg-r-8 fs-14 fw-600">mini </span>
                <el-form-item
                  ref="min_ec_prm"
                  :rules="rules.input"
                  prop="min_ec_prm">
                  <v-input
                    v-model="formData.min_ec_prm"
                    key-non-chinese
                    class="width-128"
                    :key-float-number="true"
                    prepend="$"
                    @change="handleComputed"
                  ></v-input>
                </el-form-item>
              </template>
            </div>
          </div>
        </template>
        <template v-if="!isCAR">
          <div class="form-item">
            <span>Content</span>
            <el-form-item
              ref="cal_type_contents"
              :rules="rules.select"
              prop="cal_type_contents">
              <v-radio-group
                v-model="formData.cal_type_contents"
                :list="newSMEOptions.cal_type"
                @change="handleComputed"/>
            </el-form-item>
            <div class="flex-align-center mg-t-8">
              <template v-if="formData.cal_type_contents==1">
                <el-form-item
                  ref="contents_isrd"
                  :rules="rules.input"
                  prop="contents_isrd">
                  <v-input
                    v-model="formData.contents_isrd"
                    key-non-chinese
                    class="width-128"
                    :key-float-number="true"
                    prepend="$"
                    @change="handleComputed"
                  ></v-input>
                </el-form-item>

                <span class="mg-l-8 mg-r-8">
                  <font-awesome-icon icon="xmark"></font-awesome-icon>
                </span>
                <el-form-item
                  ref="contents_pct"
                  :rules="rules.input"
                  prop="contents_pct">
                  <v-input
                    v-model="formData.contents_pct"
                    class="width-68"
                    key-non-chinese
                    :key-float-number="true"
                    append="%"
                    @change="handleComputed"
                  ></v-input>
                </el-form-item>
                <span class="mg-l-8 mg-r-8">
                  <font-awesome-icon icon="equals"></font-awesome-icon>
                </span>
              </template>
              <el-form-item
                ref="contents_prm"
                :rules="rules.input"
                prop="contents_prm">
                <v-input
                  v-model="formData.contents_prm"
                  key-non-chinese
                  :disabled="formData.cal_type_contents==1"
                  class="width-128"
                  :key-float-number="true"
                  prepend="$"
                  @blur="handleComputed"
                ></v-input>
              </el-form-item>
              <template v-if="formData.cal_type_contents==1">
                <span class="mg-l-8 mg-r-8">
                  <font-awesome-icon icon="slash"></font-awesome-icon>
                </span>
                <span class="mg-r-8 fs-14 fw-600">mini </span>
                <el-form-item
                  ref="min_sub_contents_prm"
                  :rules="rules.input"
                  prop="min_sub_contents_prm">
                  <v-input
                    v-model="formData.min_sub_contents_prm"
                    key-non-chinese
                    class="width-128"
                    :key-float-number="true"
                    prepend="$"
                    @change="handleComputed"
                  ></v-input>
                </el-form-item>
              </template>
            </div>
          </div>
          <div class="form-item">
            <span>Content (Stock)</span>
            <el-form-item
              ref="cal_type_stocks"
              :rules="rules.smeSelect"
              prop="cal_type_stocks"
              @change="handleComputed">
              <v-radio-group
                v-model="formData.cal_type_stocks"
                :list="newSMEOptions.cal_type" />
            </el-form-item>
            <div class="flex-align-center mg-t-8">
              <template v-if="formData.cal_type_stocks==1">
                <el-form-item
                  ref="stocks_isrd"
                  :rules="rules.input"
                  prop="stocks_isrd">
                  <v-input
                    v-model="formData.stocks_isrd"
                    key-non-chinese
                    :key-float-number="true"
                    prepend="$"
                    class="width-128"
                    @change="handleComputed"
                  ></v-input>
                </el-form-item>

                <span class="mg-l-8 mg-r-8">
                  <font-awesome-icon icon="xmark"></font-awesome-icon>
                </span>
                <el-form-item
                  ref="stocks_pct"
                  :rules="rules.input"
                  prop="stocks_pct">
                  <v-input
                    v-model="formData.stocks_pct"
                    class="width-68"
                    key-non-chinese
                    :key-float-number="true"
                    append="%"
                    @change="handleComputed"
                  ></v-input>
                </el-form-item>
                <span class="mg-l-8 mg-r-8">
                  <font-awesome-icon icon="equals"></font-awesome-icon>
                </span>
              </template>
              <el-form-item
                ref="stocks_prm"
                :rules="rules.input"
                prop="stocks_prm">
                <v-input
                  v-model="formData.stocks_prm"
                  key-non-chinese
                  :disabled="formData.cal_type_stocks==1"
                  :key-float-number="true"
                  prepend="$"
                  class="width-128"
                  @blur="handleComputed"
                ></v-input>
              </el-form-item>
              <template v-if="formData.cal_type_stocks==1">
                <span class="mg-l-8 mg-r-8">
                  <font-awesome-icon icon="slash"></font-awesome-icon>
                </span>
                <span class="mg-r-8 fs-14 fw-600">mini </span>
                <el-form-item
                  ref="min_sub_stocks_prm"
                  :rules="rules.input"
                  prop="min_sub_stocks_prm">
                  <v-input
                    v-model="formData.min_sub_stocks_prm"
                    key-non-chinese
                    :key-float-number="true"
                    class="width-128"
                    prepend="$"
                    @change="handleComputed"
                  ></v-input>
                </el-form-item>
              </template>
            </div>
          </div>
          <div class="form-item">
            <span>Content (Machinery)</span>
            <el-form-item
              ref="cal_type_dev"
              :rules="rules.select"
              prop="cal_type_dev">
              <v-radio-group
                v-model="formData.cal_type_dev"
                :list="newSMEOptions.cal_type"
                @change="handleComputed" />
            </el-form-item>
            <div class="flex-align-center mg-t-8">
              <template v-if="formData.cal_type_dev==1">
                <el-form-item
                  ref="high_value_dev_isrd"
                  :rules="rules.input"
                  prop="high_value_dev_isrd">
                  <v-input
                    v-model="formData.high_value_dev_isrd"
                    class="width-128"
                    key-non-chinese
                    :key-float-number="true"
                    prepend="$"
                    @change="handleComputed"
                  ></v-input>
                </el-form-item>
                <span class="mg-l-8 mg-r-8">
                  <font-awesome-icon icon="xmark"></font-awesome-icon>
                </span>
                <el-form-item
                  ref="high_value_dev_pct"
                  :rules="rules.input"
                  prop="high_value_dev_pct">
                  <v-input
                    v-model="formData.high_value_dev_pct"
                    class="width-68"
                    key-non-chinese
                    :key-float-number="true"
                    append="%"
                    @change="handleComputed"
                  ></v-input>
                </el-form-item>
                <span class="mg-l-8 mg-r-8">
                  <font-awesome-icon icon="equals"></font-awesome-icon>
                </span>
              </template>
              <el-form-item
                ref="high_value_dev_prm"
                :rules="rules.input"
                prop="high_value_dev_prm">
                <v-input
                  v-model="formData.high_value_dev_prm"
                  class="width-128"
                  :disabled="formData.cal_type_dev==1"
                  key-non-chinese
                  :key-float-number="true"
                  prepend="$"
                  @blur="handleComputed"
                ></v-input>
              </el-form-item>
              <template v-if="formData.cal_type_dev==1">
                <span class="mg-l-8 mg-r-8">
                  <font-awesome-icon icon="slash"></font-awesome-icon>
                </span>
                <span class="mg-r-8 fs-14 fw-600">mini </span>
                <el-form-item
                  ref="min_sub_dev_prm"
                  :rules="rules.input"
                  prop="min_sub_dev_prm">
                  <v-input
                    v-model="formData.min_sub_dev_prm"
                    class="width-128"
                    key-non-chinese
                    :key-float-number="true"
                    prepend="$"
                    @change="handleComputed"
                  ></v-input>
                </el-form-item>
              </template>
            </div>
          </div>
          <div class="form-item">
            <span>Public Liability</span>
            <el-form-item
              ref="total_pl_prm"
              :rules="rules.input"
              prop="total_pl_prm">
              <v-input
                v-model="formData.total_pl_prm"
                key-non-chinese
                class="width-128"
                :key-float-number="true"
                prepend="$"
                @blur="handleComputed"
              ></v-input>
            </el-form-item>
          </div>
        </template>
      </div>
      <div
        v-if="formData.employee_ind==1&&!isCAR"
        class="box">
        <h3>Employee's Compensation</h3>
        <div class="form-item">
          <el-form-item
            ref="cal_type_ec"
            :rules="rules.smeSelect"
            prop="cal_type_ec"
            @change="handleComputed">
            <v-radio-group
              v-model="formData.cal_type_ec"
              :list="newSMEOptions.cal_type" />
          </el-form-item>
        </div>
        <template v-if="formData.cal_type_ec!=2">
          <div
            v-for="(item,index) in formData.ec_prm_detail"
            :key="'ec_'+index"
            class="form-item">
            <span>{{item.title}}</span>
            <div class="flex-align-center">
              <el-form-item
              >
                <v-input
                  v-model="item.annual_salary"
                  class="width-128"
                  key-non-chinese
                  :key-float-number="true"
                  prepend="$"
                  @change="handleComputed"
                ></v-input>
              </el-form-item>
              <span class="mg-l-8 mg-r-8">
                <font-awesome-icon icon="xmark"></font-awesome-icon>
              </span>
              <el-form-item
                :ref="`ec_prm_detail.${index}.prm_pct`"
                :rules="rules.input"
                :prop="`ec_prm_detail.${index}.prm_pct`">
                <v-input
                  v-model="item.prm_pct"
                  class="width-68"
                  key-non-chinese
                  :key-float-number="true"
                  append="%"
                  @change="handleComputed"
                ></v-input>
              </el-form-item>
              <span class="mg-l-8 mg-r-8">
                <font-awesome-icon icon="equals"></font-awesome-icon>
              </span>
              <el-form-item>
                <v-input
                  v-model="item.annual_prm"
                  class="width-128"
                  key-non-chinese
                  disabled
                  :key-float-number="true"
                  prepend="$"
                ></v-input>
              </el-form-item>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="flex-align-center">
            <el-form-item
              ref="total_ec_prm"
              prop="total_ec_prm">
              <v-input
                v-model="formData.total_ec_prm"
                key-non-chinese
                class="width-128"
                :key-float-number="true"
                prepend="$"
                @blur="handleComputed"
              ></v-input>
            </el-form-item>
          </div>
        </template>
      </div>
      <div
        v-if="!isCAR"
        class="box">
        <h3>Excess</h3>
        <div
          v-for="(excess_item,index) in formData.excess"
          :key="'excess_'+index"
          class="flex-align-center">
          <div class="form-item form-half">
            <span>Item</span>
            <el-form-item
              :ref="`excess.${index}.item`"
              :rules="rules.input"
              :prop="`excess.${index}.item`">
              <v-input
                v-model="excess_item.item"
                key-non-chinese
                :rows="4"
                type="textarea"
              ></v-input>
            </el-form-item>
          </div>
          <div class="form-item form-half mg-l-20">
            <span>Content</span>
            <el-form-item
              :ref="`excess.${index}.content`"
              :rules="rules.smeSelect"
              :prop="`excess.${index}.content`">
              <v-input
                v-model="excess_item.content"
                key-non-chinese
                :rows="4"
                type="textarea"
              ></v-input>
            </el-form-item>
          </div>
          <span class="mg-l-14">
            <font-awesome-icon
              class="color-del"
              icon="trash-alt"
              @click="handleDelExcess(index)"></font-awesome-icon>
          </span>
        </div>
        <div>
          <v-button
            blue
            icon="plus"
            @click="handleAddExcess">Add</v-button>
        </div>
      </div>

      <div class="box mg-t-15">
        <h3>Premium</h3>
        <sme-premium
          ref="sme-premium"
          :customer-id="form.customer_id"
          :order-id="form.order_id"
          :form="formData"
          :is-fina="isFina"
          :detailData="form"
          :premium="formData.premium"
          :commission="formData.commission"
          :amount.sync="formData.payable"
          :is-default-referrer-pct="isDefaultReferrerPct"
          @getFormData="getFormData"
          @cal="handleComputed"></sme-premium>
      </div>
      <div
        v-if="isRefer"
        class="box">
        <h3 class="color-dark">Internal Use</h3>
        <div class="flex-sb">
          <div class="form-item form-half">
            <span>Internal Remarks</span>
            <v-input
              v-model="formData.internal_remark"
              type="textarea"
              :disabled="showBuyable"
              :rows="6" />
          </div>
          <div class="form-item form-half">
            <div class="form-item">
              <span>Proof Document</span>
              <file-container
                v-for="(fileItem, proof_index) in formData.proof_doc"
                :key="'proof_'+proof_index"
                :fileData="fileItem"
                :edit="true"
                :otherData="{
                  target: 'proof_doc',
                  proof_index
                }"
                titleName= "Documents"
                @delete="handlerDeleteFile"
                @uploadSuccess="handlerUploadSuccess" />
              <v-upload
                :otherData="{
                  target: 'proof_doc',
                }"
                titleName= "Proof Document"
                :orderUpload="true"
                @uploadSuccess="handlerUploadSuccess" />
            </div>
            <div
              class="form-item">
              <span>Documents</span>
              <file-container
                v-for="(fileItem, fileIndex) in formData.documents"
                :key="fileIndex"
                :fileData="fileItem"
                :edit="true"
                :otherData="{
                  target: 'documents',
                  fileIndex
                }"
                titleName= "Documents"
                @delete="handlerDeleteFile"
                @uploadSuccess="handlerUploadSuccess" />
              <v-upload
                :otherData="{
                  target: 'documents',
                }"
                :orderUpload="true"
                @uploadSuccess="handlerUploadSuccess" />
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </div>
<!--  </lazy-dom>-->
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'
import SmePremium from './sme-preimum'
import {replySMEQuoteDetail,replySMEQuoteCal} from '@api/new_sme'
import {mapState} from 'vuex'
import OMath from '@/utils/math'
export default {
  name: 'reply-form',
  components: {SmePremium},
  mixins: [MixinOptions, MixinFormat, MixinRules],
  props:{
    form:{
      type:Object,
      default:()=>({})
    },
    isFina:{
      type:Boolean,
      default:false
    },
    isRefer:{
      type:Boolean,
      default:false
    },
    showBuyable:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return{
      detailData:{},
      formData:{
        payable:'',
        plan_name:'',
        employee_ind:'',
        pcy_cmnt_dt:'',
        company_id:'',
        prop_pdf_path:'',
        prop_pdf_path_file:{},
        insurer_quotation_path:'',
        insurer_quotation_path_file:{},
        cal_type_contents:'',
        contents_isrd:'',
        contents_pct:'',
        contents_prm:'',
        min_sub_contents_prm:'',
        cal_type_stocks:'',
        stocks_isrd:'',
        stocks_pct:'',
        stocks_prm:'',
        min_sub_stocks_prm:'',
        cal_type_dev:'',
        high_value_dev_isrd:'',
        high_value_dev_pct:'',
        high_value_dev_prm:'',
        min_sub_dev_prm:'',
        total_pl_prm:'',
        total_ec_prm:'',
        cal_type_ec:'',
        ec_prm_detail:[],
        excess:[],
        spec_disc_prm:0,
        handling_fee:0,
        insurer_handling_fee:0,
        agency_handling_fee:0,
        code_disc_prm:0,
        code:'',
        referrer_user_id:'',
        coupon_code:'',
        premium:[],

        cal_type_materials:'',
        materials_isrd:'',
        materials_pct:'',
        min_materials_prm:'',
        materials_prm:'',
        cal_type_pl:'',
        pl_isrd:'',
        pl_pct:'',
        min_pl_prm:'',
        pl_prm:'',
        ec_isrd:'',
        main_start_dt:'',
        main_end_dt:'',
        pcy_expry_dt:'',
        ec_pct:'',
        min_ec_prm:'',
        ec_prm:'',
        main_date:[],
        date:[],
        pl_ind:'',
        materials_ind:'',
        internal_remark:'',
        proof_doc:'',
        documents:[],
        commission:[],
        referrer_net_type:1,
        referrer_net_pct:0,
        insurer_net_pct:0,
        referrer_is_special:false,
        max_code_disc_prm:'',
      },
      reply_content:''
    }
  },
  computed:{
    ...mapState('coupon', ['couponCode','selectCode']),
    isCAR(){
      let {class_id} = this.form||{}
      return class_id == 79
    },
    isDefaultReferrerPct(){
      let {stts,referrer} = this.form||{}
      const result =
        referrer && JSON.stringify(referrer) != '{}' && !(referrer instanceof Array)
      return stts==201&&result
    }
  },
  watch:{
    form:{
      immediate:true,
      handler(val){
        if(this.isRefer){
          this.formData = {...this.formData,...val}
          let {order_id,referrer} =val||{}
          let {excess,prop_pdf_path,insurer_quotation_path,pcy_cmnt_dt,pcy_expry_dt,main_start_dt='',main_end_dt=''} = val||{}
          if(!excess){
            this.formData.excess =[]
          }
          if(prop_pdf_path)
          {
            let {id} = prop_pdf_path||{}
            this.formData.prop_pdf_path_file = prop_pdf_path||{}
            this.formData.prop_pdf_path = id
          }
          if(insurer_quotation_path)
          {
            let {id} = insurer_quotation_path||{}
            this.formData.insurer_quotation_path_file = insurer_quotation_path||{}
            this.formData.insurer_quotation_path = id
          }
          this.formData.date = [pcy_cmnt_dt,pcy_expry_dt]
          this.formData.main_date = [main_start_dt,main_end_dt]
          this.formData.referrer = referrer
          this.handleUpdateData()
          this.$nextTick(()=>{
            this.$refs['sme-premium'].handlerSetCode()
            this.handleComputed()
          })
        }
      }
    },
    'formData.payable':{
      immediate:true,
      handler(val){
        this.$emit('update:amount',val)
      }
    },
    // isDefaultReferrerPct:{
    //   immediate:true,
    //   handler(val){
    //     let {referrer_net_pct} = this.formData||{}
    //     console.log('referrer_net_pct--',referrer_net_pct)
    //     if(val&&referrer_net_pct<=0){
    //       this.formData.referrer_net_pct = 10
    //     }
    //   }
    // }
  },
  mounted() {
    if(!this.isRefer)
      this.network().replySMEQuoteDetail()
  },
  methods:{
    handleUpdateData(){
      let {company_id,plan_name} = this.formData||{}
      this.$emit('updateName',{company_id,plan_name})
    },
    handleUpdateForm(){
      let {date,main_date} = this.formData||{}
      let params = {
        date,
        main_date,
        pcy_cmnt_dt:date[0],
        pcy_expry_dt:date[1],
        main_start_dt:main_date[0],
        main_end_dt:main_date[1],
      }
      this.$emit('updateForm',params)
    },
    handlerUploadSuccess({ data, result, otherData }) {
      const { idKey, nameKey, target, index = '', type } = otherData
      const { id, path,thumb_url,url } = data
      if(['proof_doc','documents'].includes(target)) {
        if(index != '') {
          this.$set(this.formData[target], index, data)
        }
        else {
          if(!this.formData[target]) {
            this.formData[target] = []
          }
          this.formData[target].push(data)
        }
      }else
      {
        this.$set(this.formData,target,data)
        this.$set(this.formData,idKey,id)
        this.$refs.form.clearValidate(idKey)
      }
    },
    handlerDeleteFile(otherData) {
      let { type, index,target,idKey } = otherData
      if(['proof_doc','documents'].includes(target))
        this.formData[target].splice(index, 1)
      else {
        this.$set(this.formData,target,{})
        this.$set(this.formData,idKey,'')
      }

    },
    handleComputed(data){
      let params = {...this.formData,...data}
      if(this.isFina&&!this.isRefer){
        params.code = ''
      }
      let {ec_prm_detail=[]} = params||{}
      if(ec_prm_detail&&ec_prm_detail.length<=0){
        delete params.ec_prm_detail
      }
      this.network().replySMEQuoteCal(params)
    },
    getFormData(data){
      this.formData= {...this.formData,...data}
    },
    handleAddExcess(){
      this.formData.excess.push({item:'',content:''})
    },
    handleDelExcess(index){
      this.formData.excess.splice(index,1)
    },
    submitForm(){
      return new Promise((resolve, reject) => {
        this.$refs['form'].validate((valid, rules) => {
          if(valid){
            let params = JSON.parse(JSON.stringify(this.formData))
            let {ec_prm_detail=[]} = params||{}
            if(ec_prm_detail.length<=0){
              delete params.ec_prm_detail
            }
            if(this.isCAR){
              let {date,main_date} = this.formData
              params = {
                ...params,
                pcy_cmnt_dt:date[0],
                pcy_expry_dt:date[1],
                main_start_dt:main_date[0],
                main_end_dt:main_date[1],
              }
            }
            resolve({...params})
          }else
            this.scrollToValidDom(rules)
          reject()
        })
      })
    },
    network(){
      return{
        replySMEQuoteDetail:async (params)=>{
          let {order_id,referrer} = this.form||{}
          let {data} = await replySMEQuoteDetail({...params,order_id})
          Object.keys(this.formData).some(key => {
            if(key in data) {
              this.formData[key] =data[key]
            }
          })
          let {excess,prop_pdf_path,insurer_quotation_path,pcy_cmnt_dt,pcy_expry_dt,main_start_dt,main_end_dt,commission} = data||{}
          if(!excess){
            this.formData.excess =[]
          }
          commission.filter(item=>{
            if(item.name!='gross'){
              this.formData[`${item.name}_pct`] = item.pct||0
              this.formData[`${item.name}_prm`] = item.premium||0
            }
          })
          if(data.prop_pdf_path)
          {
            let {id} = data.prop_pdf_path
            this.formData.prop_pdf_path_file = prop_pdf_path
            this.formData.prop_pdf_path = id
          }
          if(data.insurer_quotation_path)
          {
            let {id} = data.insurer_quotation_path
            this.formData.insurer_quotation_path_file = insurer_quotation_path
            this.formData.insurer_quotation_path = id
          }
          this.formData.date = [pcy_cmnt_dt,pcy_expry_dt]
          this.formData.main_date = [main_start_dt,main_end_dt]
          this.formData.referrer = referrer
          this.$refs['sme-premium'].handlerSetCode()
          this.handleComputed()
        },
        replySMEQuoteCal:async (params={})=>{
          let {order_id} = this.form||{}
          // let {selectCode, coupon = {}, code = {}} = this.selectCode || {}
          // if (coupon.selectCode == 1) {
          //   params.coupon_code = coupon.coupon_code
          // }
          // if (code.selectCode == 2) {
          //   params.code = code.code
          // }
          // console.log('this.selectCode==',this.selectCode)
          if(this.isCAR){
            let {date,main_date} = this.formData
            params = {
              ...params,
              pcy_cmnt_dt:date[0],
              pcy_expry_dt:date[1],
              main_start_dt:main_date[0],
              main_end_dt:main_date[1],
            }
          }
          let {data} = await replySMEQuoteCal({...params,order_id})
          Object.keys(this.formData).some(key => {
            if(key in data) {
              this.formData[key] =data[key]
            }
          })
          let {referrer} = data||{}
          this.$emit('updateRefer',referrer)
        },
      }
    }
  }

}
</script>

<style lang="scss" scoped>
/deep/.policy-form{
  width: 690px!important;
}
.policy-form{
  width: 690px!important;
  max-width: 690px;
  .box {
    padding-bottom: 15px;
    h3{
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #24292E;
    }
  }
  .travel-box{
    .flex{
      flex-wrap: wrap;
    }
  }
  .margin-top{
    margin-top: 10px;
  }
  .gray{
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #24292E;
    display: inline-block;
  }
}
/deep/ .max-content{
  width: max-content;
}
.select-time{
  .el-date-editor{
    width: 100%;
  }
}
.form-item{
  >span{
    &:first-child {
      display: block;
      padding-bottom: 8px;
    }
  }
  .sme--content__tip{
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #586069;
    padding-bottom: 0;
  }
  /deep/.v-radio-group{
    .el-radio-group{
      .el-radio{
        margin-right: 20px!important;
      }
    }
  }
  .width-68{
    width: 78px;
    /deep/.el-input__inner{
      padding: 0 10px!important;
    }
  }
  .width-128{
    width: 128px;
    /deep/.el-input__inner{
      padding: 0 10px!important;
    }
  }
  /deep/.el-form-item{
    .el-input-group--append{
      //.el-input__inner{
      //  border-right: 0;
      //}
    }
    .el-input-group__append{
      padding: 0 5px;
      border-left: 0;
      //background: #fff;
    }
    .el-input-group__prepend{
      border-right: 0;
      //background: #fff;
    }
  }

}
</style>
